import {
  alertDescription
} from "./chunk-37NVE66J.mjs";
import {
  useAlertContext
} from "./chunk-Z4HKIJIY.mjs";

// src/components/alert-description/AlertDescription.tsx
import { Typography } from "@julo-ui/typography";
import { forwardRef, cx } from "@julo-ui/system";
import { jsx } from "react/jsx-runtime";
var AlertDescription = forwardRef(
  (props, ref) => {
    const { children, className, sx, ...resProps } = props;
    const { status = "neutrals" } = useAlertContext(
      "AlertDescription should be within Alert"
    );
    return /* @__PURE__ */ jsx(
      Typography,
      {
        bold: true,
        as: "div",
        type: "caption",
        ref,
        sx: { ...alertDescription[status], ...sx },
        className: cx("julo-alert__description", className),
        ...resProps,
        children
      }
    );
  }
);
AlertDescription.displayName = "AlertDescription";
var AlertDescription_default = AlertDescription;

export {
  AlertDescription_default
};
